export default "__VITE_ASSET__xXwBrPsR__"